import { Component, OnInit } from '@angular/core';
import { PlatformInfo } from '@root/config';
import _ from 'lodash';
import * as moment from 'moment';
import { interval } from 'rxjs';
import { take, tap, last } from 'rxjs';

import { AccountService } from '@root/router/channel/account/account.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@root/shared/service/translate.service';

@Component({
  selector: 'host-read-orders',
  templateUrl: './read-orders.component.html',
  styleUrls: ['./read-orders.component.scss'],
})
export class ReadOrdersComponent implements OnInit {
  accountList = [];
  constructor(
    // private messageService: MessageService,
    private accountService: AccountService,
    private messageService: NzMessageService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.getAccountList();
  }

  getAccountList() {
    const params = {
      page: 1,
      page_size: 1000000,
      format: 'read_reservation',
    };
    this.accountService.getThirdpartyList(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.accountList = [];
        const list = _.get(res, 'data.list');
        this.formatData(list);
      }
    });
  }

  formatData(data) {
    _.forEach(data, (item) => {
      const syn_time = moment().diff(moment(item.last_sync_reservation_time), 's');
      let time;
      if (syn_time) {
        time =
          syn_time < 0
            ? null
            : syn_time < 60
            ? `${syn_time}s`
            : syn_time < 3600
            ? `${Math.floor(syn_time / 60)}min`
            : `${Math.floor(syn_time / 3600)}h`;
      }
      this.accountList.push({
        channel: item.thirdparty_type,
        icon: _.get(PlatformInfo[item.thirdparty_type], 'icon_color_bg'),
        username: _.get(item, 'username'),
        syn_time: time,
        lock_cache_ttl: item.lock_cache_ttl,
        id: item.id,
      });
    });
    _.forEach(this.accountList, (item) => {
      if (item.lock_cache_ttl > 0) {
        _.assign(item, {
          timer: null,
          action: {
            disabled: true,
            text: null,
          },
        });
        item.timer = interval(1000)
          .pipe(
            take(item.lock_cache_ttl),
            tap((s) => {
              // ${item.lock_cache_ttl - s - 1}s后可读取
              item.action.text = this.translateService.syncGet('order.readable_in_over_time', {
                time: item.lock_cache_ttl - s - 1,
              });
            }),
            last()
          )
          .subscribe(() => {
            item.action.disabled = false;
            // 读取日历
            item.action.text = this.translateService.syncGet('order.read_order');
            item.timer.unsubscribe();
            item.timer = null;
          });
      } else {
        _.assign(item, {
          action: {
            disabled: false,
            text: this.translateService.syncGet('order.read_order'),
          },
          timer: null,
        });
      }
    });
  }

  synchronise(i) {
    const account = this.accountList[i];
    if (account.action.disabled) {
      return;
    }
    const params = {
      thirdparty_account_id: account.id,
    };
    this.accountService.syncerReservations(params).subscribe((res) => {
      if (res.error_code === 0) {
        // this.messageService.replace(
        //   Type.SYNC_ACCOUNT_RESERVATIONS,
        //   new NotifyModel({
        //     type: `${Type.SYNC_ACCOUNT_RESERVATIONS}${account.id}`,
        //     status: Status.DOING,
        //     payload: {
        //       title: `${account.thirdparty.name}${account.user_name}订单读取中，请等待...`,
        //       desc: ''
        //     }
        //   }),
        //   { position: 'center' }
        // );
        const channel = this.translateService.syncGet(`word.channel_${account.channel}`);
        const title = this.translateService.syncGet('order.reading_orders', {
          channel: channel,
          user: account.username,
        });
        this.messageService.warning(title);
        account.timer = interval(1000)
          .pipe(
            take(300),
            tap((s) => {
              account.action.text = this.translateService.syncGet('order.readable_in_over_time', { time: 300 - s - 1 });
              account.action.disabled = true;
            }),
            last()
          )
          .subscribe(() => {
            account.action.disabled = false;
            // account.action.text = "读取日历";
            account.action.text = this.translateService.syncGet('order.read_order');
            account.timer.unsubscribe();
            account.timer = null;
          });
      }
    });
  }
}
